import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { getMainPlayerWidget } from '../../../common/components/Player/helpers';
import { getLinks, getMentions, getText } from '../../../common/helpers/comments';
import { gqlRequest } from '../../../common/helpers/request';
import { editCommentAction, getCommentsAndSummaryAction } from '../slices/comments';

const queryGQL = `
  mutation hostedWatchEditComment(
      $commentId: String,
      $params: HostedWatchEditCommentInput,
  ) {
    hostedWatchEditComment(
      commentId: $commentId,
      params: $params,
    ) {
        activeChildCount,
        deletedChildCount,
        time,
        id,
        index,
        parentId,
        status,
        created,
        html,
        author {
          id,
          firstName,
          lastName,
        }
    }
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(editCommentAction.type),
    switchMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: {
          commentId: payload.commentId,
          params: {
            body: payload.body,
            html: payload.html,
            mentions: payload.mentions,
            urlComment: payload.urlComment,
            urlVideo: payload.urlVideo,
          },
        },
      }).pipe(
        switchMap(({ errors }) => {
          const actions = [];

          if (errors.length) {
            const getCommentsInfoPayload = {
              videoId: payload.videoId,
              videoTime: {
                from: 0,
              },
              from: 0, // portion start
              size: 10000,
            };

            actions.push(of(getCommentsAndSummaryAction(getCommentsInfoPayload)));
          } else {
            const LWP = getMainPlayerWidget();

            LWP.sendStatsEditComment(
              payload.parentId ? 2 : 1,
              payload.index,
              getText(payload.html).length,
              !!getMentions(payload.html).length,
              !!getLinks(payload.html).length,
            );
          }

          return concat(...actions);
        }),
      ),
    ),
  );
